import { QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { RouterProvider } from "react-router-dom";

import { makeQueryClient } from "./queryClient";
import { createAppRouter } from "./router";

export { makeQueryClient };

export function App() {
  const [client] = useState(makeQueryClient);
  const [router] = useState(createAppRouter);
  return (
    <QueryClientProvider client={client}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
